import { EnvMicroPayroll } from "lib-klab-core";

export const envPayrollLocal: EnvMicroPayroll = {
  host: "",
  apiBasePath: "/ms-payroll",
  useMocks: false,
};

export const envPayrollDev: EnvMicroPayroll = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-payroll",
  useMocks: false,
};

export const envPayrollProd: EnvMicroPayroll = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-payroll",
  useMocks: false,
};
